import React from "react";
import { Check, Loader2, UserMinus, UserPlus } from "lucide-react";
import generateAvatarUrl from "../../utils/generateAvatarUrl";
import {
  formatUserLevel,
  getConnectionActionMeta,
  getConnectionFavoriteChips,
} from "../../utils/profileHelpers";

const ProfileConnectionRow = ({
  user,
  listType,
  isFollowing,
  onToggle,
  busy = false,
}) => {
  const action = getConnectionActionMeta({ isFollowing, listType });
  const note = String(user?.notes || "").trim();
  const chips = getConnectionFavoriteChips(user);

  const ActionIcon =
    action.variant === "danger"
      ? UserMinus
      : isFollowing
      ? Check
      : UserPlus;

  return (
    <article className="prof-conn-row">
      <img
        className="prof-conn-avatar"
        src={generateAvatarUrl(user?.name || "Member")}
        alt=""
        width={36}
        height={36}
      />

      <div className="prof-conn-copy">
        <div className="prof-conn-name-row">
          <strong>{user?.name || "Member"}</strong>
          <span className="prof-level-pill">{formatUserLevel(user?.userLevel)}</span>
        </div>
        {note ? <p className="prof-conn-note">"{note}"</p> : null}
        {chips.length ? (
          <div className="prof-conn-chips">
            {chips.slice(0, 2).map((chip) => (
              <span key={chip.label} className="prof-conn-chip">
                {chip.label}
              </span>
            ))}
          </div>
        ) : null}
      </div>

      <button
        type="button"
        className={`prof-conn-action prof-conn-action-${action.variant}`}
        onClick={() => onToggle?.(user)}
        disabled={busy}
        aria-label={action.label}
      >
        {busy ? (
          <Loader2 size={10} className="animate-spin" aria-hidden />
        ) : (
          <>
            <ActionIcon size={10} aria-hidden />
            <span>{action.label}</span>
          </>
        )}
      </button>
    </article>
  );
};

export default ProfileConnectionRow;
